import React from 'react'
import { Button, Dialog, TextField, Typography, useMediaQuery } from '@mui/material'
import { Link } from 'react-router-dom'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import useStyles from './_styles'
import useButtonStyles from '../../../styles/buttonsStyles'
import useFormStyles from '../../../styles/formsStyles'
import PlannedConsultationListFilter from './PlannedConsultationListFilter'
import PageContentHeader from '../../Common/pageContent/PageContentHeader'
import { PlannedConsultationHeaderProps } from './_props'
import { defaultPalette } from '../../../theme/idsTheme'

const PlannedConsultationHeader = ({
    setSearch,
    search,
    requiredExperts,
    handleFiltersChange,
    filters,
    handleResetFilter,
    isPreview,
    previewTitle,
    renderLeftHeader,
    disabled,
}: PlannedConsultationHeaderProps) => {
    const classes = useStyles()
    const buttons = useButtonStyles()
    const forms = useFormStyles()
    const [isSearchDialogOpen, setIsSearchDialogOpen] = React.useState(false)

    const isLargeScreen = useMediaQuery('(min-width:1000px)')

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
    }

    const handleOpenSearchDialog = () => {
        setIsSearchDialogOpen(!isSearchDialogOpen)
    }

    const renderPatientSearchField = () => (
        <TextField
            defaultValue={search}
            onInput={handleOnChange}
            label={
                <Typography className={forms.SearchFieldLabel}>
                    <SearchRoundedIcon />
                    <span>Recherche par patient</span>
                </Typography>
            }
            className={forms.SearchField}
            id="outlined-basic"
            variant="outlined"
            disabled={disabled}
            sx={{
                opacity: !disabled ? 1 : 0.54,
                '& .endAdornmentLocked': {
                    '> svg': {
                        opacity: 1,
                        color: `${defaultPalette.typography.main}`,
                    },
                },
            }}
        />
    )

    const renderPatientSearchDialog = () => (
        <>
            <Button
                onClick={handleOpenSearchDialog}
                className={buttons.ButtonBlack}
                disableElevation
                variant="contained"
                disabled={disabled}
            >
                <SearchRoundedIcon />
            </Button>
            <Dialog
                open={isSearchDialogOpen}
                onClose={handleOpenSearchDialog}
                classes={{
                    paper: classes.PlannedConsultationHeaderSearchDialogPaper,
                }}
            >
                <Typography>Recherche par patient</Typography>
                {renderPatientSearchField()}
            </Dialog>
        </>
    )

    const renderSearch = !isPreview && renderLeftHeader

    // homepage
    if (isPreview) {
        return (
            <div className={classes.PlannedConsultationHeader}>
                <PageContentHeader
                    left={
                        <div className={classes.PlannedConsultationHeaderLeft}>
                            {isPreview && previewTitle}
                            {renderSearch && (isLargeScreen ? renderPatientSearchField() : renderPatientSearchDialog())}
                            {renderSearch && (
                                <PlannedConsultationListFilter
                                    requiredExperts={requiredExperts}
                                    handleFiltersChange={handleFiltersChange}
                                    filters={filters}
                                    handleResetFilter={handleResetFilter}
                                    disabled={disabled}
                                />
                            )}
                        </div>
                    }
                    right={
                        <div className={classes.PlannedConsultationHeaderRight}>
                            <Button
                                to="/planned-consultation"
                                component={Link}
                                startIcon={<AddCircleRoundedIcon />}
                                className={buttons.ButtonBlack}
                                disableElevation
                                variant="contained"
                                data-cy="AddPlannedTlc"
                                disabled={disabled}
                            >
                                Nouvelle téléconsultation
                            </Button>
                        </div>
                    }
                />
            </div>
        )
    }

    // /planned-consultation
    return (
            <div className={classes.PlannedConsultationHeaderWrapper}>
              <div className={classes.PlannedConsultationHeaderButtonsContainer}>
                <PageContentHeader
                    left={
                        <div className={classes.PlannedConsultationHeaderLeft}>
                            {renderSearch && (isLargeScreen ? renderPatientSearchField() : renderPatientSearchDialog())}
                            {renderSearch && (
                                <PlannedConsultationListFilter
                                    requiredExperts={requiredExperts}
                                    handleFiltersChange={handleFiltersChange}
                                    filters={filters}
                                    handleResetFilter={handleResetFilter}
                                    disabled={disabled}
                                />
                            )}
                        </div>
                    }
                    right={
                        <div className={classes.PlannedConsultationHeaderRight}>
                            <Button
                                to="/planned-consultation"
                                component={Link}
                                startIcon={<AddCircleRoundedIcon />}
                                className={buttons.ButtonBlack}
                                disableElevation
                                variant="contained"
                                data-cy="AddPlannedTlc"
                                disabled={disabled}
                            >
                                Nouvelle téléconsultation
                            </Button>
                        </div>
                    }
                />
                </div>
            </div>
        )
}

export default PlannedConsultationHeader
